export default __webpack_public_path__ + "static/media/system_05_02.0cc6af9b.jpg";